import { IBannerData } from './../../../models/banner.model';
import { isPlatformBrowser } from '@angular/common';
import { Component, HostListener, OnInit, PLATFORM_ID, Inject, OnDestroy } from '@angular/core';
import { ViewportScroller } from '@angular/common';
import { ListsService } from './../../../services/lists.service';
import { OrderService } from './../../../services/order.service';
import { RouterLink } from '@angular/router';
import { BannerService } from 'src/app/services/banner.service';
import { SKELETON_LIST } from '../../utils';
import { AppStateCart } from 'src/app/state/cart/cart.reducer';
import { Store } from '@ngrx/store';
import { Message } from 'src/app/models/recomendations.model';
import { CarouselService } from 'src/app/services/carousel.service';
import { Subject, takeUntil } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { ProductPromoComponent } from '../product-promo/product-promo.component';
import { ProductCardComponent } from '../product-card/product-card.component';
import { IvyCarouselModule } from 'angular-responsive-carousel2';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
  selector: 'app-suggestions',
  templateUrl: './suggestions.component.html',
  styleUrls: ['./suggestions.component.scss'],
  standalone: true,
  imports: [MatFormFieldModule, RouterLink, MatButtonModule, IvyCarouselModule, ProductCardComponent, ProductPromoComponent, TranslateModule]
})
export class SuggestionsComponent implements OnInit, OnDestroy {

  public screenWidth: number;
  public promos: IBannerData[] = [];
  public isMobile: boolean;
  public carouselProductsHeight = 364;
  public carouselProductsWidth = 200;
  public skeletonList = SKELETON_LIST;
  public isBrowser = isPlatformBrowser(this.platformId);
  @HostListener('window:resize', ['$event'])
  onResize(): void {
    if (this.isBrowser) {
      this.screenWidth = window.innerWidth;
      this.isMobile = window.innerWidth <= 800;
    }
    this.carouselProductsHeight = this.isMobile ? 270 : 335;
    this.carouselProductsWidth = this.isMobile ? 200 : 200;
  }
  private subs = new Subject<void>();
  public cartItems: any[] = [];
  public favouritesList: any;

  public token: any;
  public storeId: number;
  public carouselRecommendations: Message = {
    name: '',
    items: [],
    total_items: 0,
    see_more: false
  };

  constructor(
    private bannerService: BannerService,
    @Inject(PLATFORM_ID) private platformId: string,
    private orderService: OrderService,
    private listsService: ListsService,
    private scroll: ViewportScroller,
    private store: Store<AppStateCart>,
    private caoruselService: CarouselService,
  ) {
    if (this.isBrowser) {
      this.token = localStorage.getItem('token');
      this.storeId = JSON.parse(localStorage.getItem('address') || '{}').store;
    }
    this.store.select('cart').pipe(takeUntil(this.subs)).subscribe(({ info }) => {
      this.cartItems = info?.items;
    });
  }

  async ngOnInit(): Promise<void> {
    if (this.isBrowser) {
      this.screenWidth = window.innerWidth;
      this.isMobile = window.innerWidth <= 800;
    }
    this.carouselProductsHeight = this.isMobile ? 270 : 335;
    this.carouselProductsWidth = this.isMobile ? 200 : 200;
    this.scrollTop();
    this.getSuggestedCarousel();
    await this.getFavourites();
    this.getPromotions();
    this.orderService.refreshHome$.pipe(takeUntil(this.subs)).subscribe(async (res: boolean) => {
      if (res) {
        this.scrollTop();
        this.getSuggestedCarousel();
        await this.getFavourites();
        this.getPromotions();
      }
    });
  }

  ngOnDestroy(): void {
    this.subs.next();
    this.subs.complete();
  }

  public scrollTop(): void {
    this.scroll.scrollToPosition([0, 0]);
  }

  public async getFavourites(): Promise<void> {
    if (this.isBrowser) {
      const token = JSON.parse(localStorage.getItem('token') || '{}');
      if (token?.jwt) {
        try {
          const res = await this.listsService.getFavouritesLists();
          this.favouritesList = res.data;
        } catch (error) { }
      }
    }
  }

  public getPromotions(): void {
    this.promos = [];
    let storeId;
    if (this.isBrowser) storeId = JSON.parse(localStorage.getItem('address') || '{}').store;
    this.bannerService.getBanners(this.isMobile ? '2' : '1', '5', storeId).subscribe(({ data }) => {
      this.promos = data;
      this.promos = this.promos.filter((promo: any) => promo.active);
      this.promos.forEach((promo: any) => {
        const descArr = promo.name.split(' ');
        const desc = descArr.join('-');
        promo.carrousel_url = `/carrusel/${desc}`;
      });
      if (this.cartItems?.length && this.promos[0]?.items?.length) {
        this.cartItems.forEach((item: any) => {
          this.promos.forEach((item2: any) => {
            item2.items.forEach((item3: any) => {
              if (item.item_id === item3.id) {
                item3.productFromCart = item;
              }
            });
          });
        });
      }
      if (this.favouritesList?.items?.length && this.promos[0]?.items?.length) {
        this.favouritesList.items.forEach((el: any) => {
          el.items.forEach((item: any) => {
            this.promos[0].items.forEach((item2: any) => {
              if (item.sku === item2.sku || item.sku === item2.id) {
                item2.showHeart = true;
              }
            });
          });
        });
      }
    });
  }

  public onSeeMoreNavigation(): void {
    if (this.isBrowser) window.scroll(0, 0);
  }

  public changeName(name: string): string {
    const nameArr = name.split('-');
    return nameArr.join(' ');
  }

  private getSuggestedCarousel(): void {
    if (this.token && this.storeId) {
      this.caoruselService.getSuggestedCarousel(this.storeId, true).subscribe(({ data }) => {
        this.carouselRecommendations = data.message;
      });
    }
  }
}
